import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// STYLES
import styles from './divider.module.scss';
import FormCol from 'routers/interface/forms/tools/FormCol';

// MAIN COMPONENT
const Divider = ({
  className,
  cols = {}
}) => (
  <FormCol cols={{
    xs: 24,
    ...cols
  }}>
    <hr
      className={clsx(
        styles.divider,
        className
      )}
    />
  </FormCol>
)

// EXPORT
export default Divider;
